import type { Router } from "@core/Api/Router";
import type ApiUrlCreator from "@core-ui/ApiServices/ApiUrlCreator";
import FetchService from "@core-ui/ApiServices/FetchService";
import ModalToOpenService from "@core-ui/ContextServices/ModalToOpenService/ModalToOpenService";
import { GesCloudApi } from "@ext/enterprise-cloud/GesCloudApi";
import initEnterpriseCloud from "@ext/enterprise-cloud/utils/initEnterpriseCloud";
import enterGesCloudOrganization from "./enterGesCloudOrganization";

const completeGesCloudDesktopLogin = async (
	oneTimeCode: string | undefined,
	apiUrlCreator: ApiUrlCreator,
	router: Router,
	gesCloudUrl: string,
) => {
	if (oneTimeCode) {
		const { url, organizationId } = await new GesCloudApi(gesCloudUrl).setInitDesktopData(oneTimeCode);
		const receivedUrl = organizationId ? await enterGesCloudOrganization(gesCloudUrl, organizationId) : url;
		await FetchService.fetch(apiUrlCreator.setGesCloudUrl(receivedUrl));
	}

	ModalToOpenService.resetValue();
	void initEnterpriseCloud(router, apiUrlCreator);
};

export default completeGesCloudDesktopLogin;
